/**
 * Good Game Official Theme Interactions
 * Custom JS handling variant swatch dynamic swapping, mobile drawer navigation,
 * AJAX cart sync, and customer subscription feedback.
 */

document.addEventListener('DOMContentLoaded', () => {
  initVariantSwatches();
  initMobileMenu();
  initNewsletterAjax();
});

/**
 * Live Variant Swatch Image Swapping
 */
function initVariantSwatches() {
  const swatchButtons = document.querySelectorAll('[data-swatch-image]');

  swatchButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const targetImgId = btn.getAttribute('data-target-img');
      const newSrc = btn.getAttribute('data-swatch-image');
      const parentContainer = btn.closest('.gg-swatch-list');

      if (targetImgId && newSrc) {
        const targetImg = document.getElementById(targetImgId);
        if (targetImg) {
          targetImg.src = newSrc;
        }
      }

      if (parentContainer) {
        parentContainer.querySelectorAll('.gg-swatch-dot').forEach((dot) => {
          dot.classList.remove('active');
        });
        btn.classList.add('active');
      }
    });
  });
}

/**
 * Mobile Navigation Drawer Toggle
 */
function initMobileMenu() {
  const menuToggleBtn = document.getElementById('gg-mobile-menu-trigger');
  const mobileMenuDrawer = document.getElementById('gg-mobile-menu-drawer');

  if (menuToggleBtn && mobileMenuDrawer) {
    menuToggleBtn.addEventListener('click', () => {
      const isExpanded = menuToggleBtn.getAttribute('aria-expanded') === 'true';
      menuToggleBtn.setAttribute('aria-expanded', !isExpanded);
      mobileMenuDrawer.classList.toggle('hidden');
    });
  }
}

/**
 * Customer Newsletter Form Handling
 */
function initNewsletterAjax() {
  const newsletterForms = document.querySelectorAll('form[action*="/contact"]');

  newsletterForms.forEach((form) => {
    form.addEventListener('submit', () => {
      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerText = 'SUBSCRIBING...';
      }
    });
  });
}